import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IQuotationType } from 'app/shared/model/quotation.model';

const initialState: IQuotationType = {
  selectedQuotationOption: 'international',
};

const quotationTypeSlice = createSlice({
  name: 'quotationType',
  initialState,
  reducers: {
    setQuotationType(state, action: PayloadAction<string>) {
      state.selectedQuotationOption = action.payload;
    },
    resetQuotationType(state) {
      state.selectedQuotationOption = 'international';
    },
  },
});

export const { setQuotationType, resetQuotationType } = quotationTypeSlice.actions;
export default quotationTypeSlice.reducer;
